import { useCallback } from "react";
import { EFormAction } from "../constants";

function getNextExpanded(
  expanded: string[],
  panel: string,
  isExpanded: boolean
): string[] {
  if (isExpanded) {
    return expanded.includes(panel) ? expanded : [...expanded, panel];
  }

  return expanded.includes(panel)
    ? expanded.filter((item) => item !== panel)
    : expanded;
}

/**
 * Custom hook to handle accordion expand/collapse logic for multi-panel accordions.
 * @param osdNumber - The current entry number (used to determine edit/view state)
 * @param setExpanded - State setter for expanded panels (array of panel ids)
 * @param setFormFieldsDisabled - Setter for form field disabled state
 * @param reset - Function to reset the form (accepts EFormAction)
 * @returns handleAccordionChange function for use in accordion onChange
 */
export function useAccordionExpand({
  osdNumber,
  expanded,
  setExpanded,
  setFormFieldsDisabled,
  reset,
}: {
  osdNumber: number | string | undefined;
  expanded: string[];
  setExpanded: React.Dispatch<React.SetStateAction<string[]>>;
  setFormFieldsDisabled: (val: boolean) => void;
  reset: (action: any) => void;
}) {
  return useCallback(
    (panel: string, isDisabled: boolean = false,) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      if (isDisabled || (["panel2", "panel3"].includes(panel) && isExpanded && !osdNumber)) {
        return;
      }

      if (osdNumber) {
        setFormFieldsDisabled(true);
        reset(EFormAction.edit);
      } else {
        reset(EFormAction.create);
      }

      setExpanded(getNextExpanded(expanded, panel, isExpanded));
    },
    [expanded, osdNumber, setExpanded, setFormFieldsDisabled, reset]
  );
}
